(function () {
  'use strict';
  function shippingEligible(data) {return data.currency === 'EUR' && ['AT','DE'].includes(data.country) && data.threshold > 0;}
  function selectAddons(data, product) {
    if (!product && !data.items.length) return [];
    const existing=new Set(data.items.map(item=>item.productId));
    const covered=new Set(data.items.flatMap(item=>item.provides||[]));
    if(product){existing.add(product.productId);(product.provides||[]).forEach(feature=>covered.add(feature));}
    const seen=new Set();
    let relevant=(product ? product.candidates : (data.candidateGroups||[]).flat()).filter(item=>{
      if(!item.id || item.price<=0 || existing.has(item.productId) || seen.has(item.productId))return false;
      if(item.provides?.length && item.provides.every(feature=>covered.has(feature)))return false;
      seen.add(item.productId);return true;
    }).sort((a,b)=>a.rank-b.rank);
    // Shipping only adjusts the order within this already curated, relevant selection.
    const gap=!product && shippingEligible(data) ? Math.max(0,data.threshold-data.total) : 0;
    if(gap>0 && gap<=2000){
      const bridge=relevant.filter(item=>item.price>=gap && item.price-gap<=500).sort((a,b)=>a.price-b.price||a.rank-b.rank)[0];
      if(bridge)relevant=[bridge,...relevant.filter(item=>item!==bridge)];
    }
    const selected=[];
    for(const item of relevant){
      if(item.provides?.length && item.provides.every(feature=>covered.has(feature)))continue;
      selected.push(item);(item.provides||[]).forEach(feature=>covered.add(feature));
      if(selected.length===2)break;
    }
    return selected;
  }
  if(typeof document==='undefined'){module.exports={selectAddons,shippingEligible};return;}
  const configElement=document.querySelector('[data-ul-conversion-config]');if(!configElement)return;
  const config=JSON.parse(configElement.textContent);configElement.dataset.ready='true';
  const root=config.root;
  const format=value=>new Intl.NumberFormat(document.documentElement.lang||'de',{style:'currency',currency:config.currency}).format(value/100);
  const node=(tag,text,className)=>{const el=document.createElement(tag);if(text)el.textContent=text;if(className)el.className=className;return el;};
  let busy=false,generation=0,timer;
  const productContexts=()=>Array.from(document.querySelectorAll('[data-ul-product-recommendations]')).map(container=>({container,data:JSON.parse(container.querySelector('[data-ul-product-addon-data]').textContent)}));
  function renderSlot(slot,items,data,placement){
    const wasOpen=slot.querySelector('details')?.open;
    slot.replaceChildren();slot.hidden=!items.length;if(!items.length)return;
    const product=placement==='product';
    const box=node('section',null,product?'ul-paired-products':'ul-cart-addons');
    box.append(node('h3',product?config.productHeading:config.heading));
    if(product)box.append(node('p',config.optional,'ul-paired-products__intro'));
    const gap=!product && shippingEligible(data)?Math.max(0,data.threshold-data.total):0;
    let extra;
    if(!product && items.length>1){extra=node('details',null,'ul-mobile-details ul-more-addons');extra.open=wasOpen ?? !window.matchMedia('(max-width:749px)').matches;extra.append(node('summary',config.more));}
    for(const item of items){
      const card=node('div',null,'ul-cart-addon');
      const imageLink=node('a');imageLink.href=item.url;imageLink.tabIndex=-1;imageLink.setAttribute('aria-hidden','true');
      const img=node('img');img.src=item.image;img.alt='';img.width=64;img.height=64;img.loading='lazy';imageLink.append(img);card.append(imageLink);
      const body=node('div',null,'ul-cart-addon__body');const link=node('a');link.href=item.url;link.append(node('span',item.title,'ul-addon-title-full'),node('span',item.shortTitle||item.title.split(' – ')[0],'ul-addon-title-short'));body.append(link);
      if(item.reason)body.append(node('small',item.reason,'ul-addon-reason'));
      body.append(node('strong',format(item.price)));
      if(gap && item.price>=gap)body.append(node('small',config.reaches,'ul-addon-shipping'));
      const button=node('button',config.add,'ul-conversion-button');button.type='button';button.dataset.ulAddItems=JSON.stringify([{id:item.id,quantity:1}]);button.dataset.ulRecommendation=placement;button.setAttribute('aria-label',config.add+': '+item.title);body.append(button);
      const status=node('p',null,'ul-conversion-status');status.setAttribute('role','status');status.setAttribute('aria-live','polite');body.append(status);
      card.append(body);
      if(extra && item!==items[0])extra.append(card);else box.append(card);
    }
    if(extra)box.append(extra);
    slot.append(box);
  }
  function render(data){
    const items=selectAddons(data);
    document.querySelectorAll('[data-ul-addons-slot]').forEach(slot=>renderSlot(slot,items,data,slot.closest('.page-cart')?'cart':'drawer'));
    productContexts().forEach(({container,data:product})=>renderSlot(container.querySelector('[data-ul-product-addons-slot]'),selectAddons(data,product),data,'product'));
  }
  async function refresh(){
    if(busy || !document.querySelector('[data-ul-addons-slot],[data-ul-product-recommendations]'))return;
    const current=++generation;
    try{
      const url=new URL(root,window.location.origin);url.searchParams.set('section_id','ul-cart-addons');
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error('Unavailable');
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');const payload=parsed.querySelector('[data-ul-addon-data]');if(!payload)throw Error('Unavailable');
      const data=JSON.parse(payload.textContent);if(current!==generation)return;render(data);
    }catch(_){
      if(current===generation)document.querySelectorAll('[data-ul-addons-slot],[data-ul-product-addons-slot]').forEach(slot=>{slot.replaceChildren();slot.hidden=true;});
    }
  }
  const schedule=()=>{clearTimeout(timer);timer=setTimeout(refresh,120);};
  function refreshThemeCart(){
    if(typeof ajaxCart!=='undefined' && typeof ajaxCart.load==='function' && document.querySelector('.js-drawer')){
      ajaxCart.load();document.body.classList.add('drawer--open');return true;
    }
    return false;
  }
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-ul-add-items]');if(!button)return;
    event.preventDefault();if(busy)return;
    busy=true;++generation;
    const original=button.textContent;const status=button.parentElement.querySelector('.ul-conversion-status');
    document.querySelectorAll('[data-ul-add-items]').forEach(el=>el.disabled=true);button.textContent=config.adding;if(status)status.textContent='';
    try{
      const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:JSON.parse(button.dataset.ulAddItems)})});
      const data=await response.json();if(!response.ok)throw Error(data.description||config.error);
      if(!button.dataset.ulRecommendation || window.location.pathname.replace(/\/$/,'')===root.replace(/\/$/,'')+'/cart'){
        window.location.assign(root+'cart');return;
      }
      if(!refreshThemeCart()){window.location.assign(root+'cart');return;}
      if(status)status.textContent=config.added;
      document.dispatchEvent(new CustomEvent('ul:recommendation-added',{detail:{placement:button.dataset.ulRecommendation,variantId:JSON.parse(button.dataset.ulAddItems)[0].id,productId:config.productId}}));
      busy=false;schedule();
    }catch(_){
      if(status){status.textContent=config.error;const cartLink=node('a',config.checkCart);cartLink.href=root+'cart';status.append(' ',cartLink);}
      busy=false;
    }finally{
      button.textContent=original;document.querySelectorAll('[data-ul-add-items]').forEach(el=>el.disabled=false);
    }
  },true);
  const observer=new MutationObserver(records=>{
    if(records.every(record=>record.target.nodeType===1 && record.target.closest('[data-ul-addons-slot]')))return;
    schedule();
  });
  document.querySelectorAll('[data-cart-container],[data-cartpage-container]').forEach(el=>observer.observe(el,{childList:true,subtree:true,characterData:true}));
  const compact=window.matchMedia('(max-width:749px)');
  function syncDetails(){document.querySelectorAll('.ul-mobile-details').forEach(el=>{el.open=!compact.matches;});}
  compact.addEventListener('change',syncDetails);syncDetails();
  document.addEventListener('shopify:section:load',syncDetails);
  document.addEventListener('shopify:section:load',schedule);window.addEventListener('pageshow',schedule);schedule();
})();

